import apiService from '../apiService';

const FLAT_FEES_URL = 'setup/flat_fees';
const flatFeesService = {
  
    async createFlatFees(payload) {
        try {
            const response = await apiService.post(`/${FLAT_FEES_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllFlatFees() {
        try {
            const response = await apiService.get(`/${FLAT_FEES_URL}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getSingleFlatFees(id) {
        try {
            const response = await apiService.get(`/${FLAT_FEES_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateFlatFees(payload, id) {
        try {
            const response = await apiService.put(`/${FLAT_FEES_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteFlatFees(id) {
        try {
            const response = await apiService.delete(`/${FLAT_FEES_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },


};

export default flatFeesService;